import { Component, OnInit } from '@angular/core';
import { CaseService } from 'src/app/services/case.service';
import { EfileService } from 'src/app/services/efile.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { SystemService } from 'src/app/services/system.service';
import { CookieService } from 'ngx-cookie-service';
import * as theGlobals from 'src/app/shared/globals';
import { MsalService } from '@azure/msal-angular';
import { EventEmitterService} from "src/app/services/event-emitter.service";
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { LoggedInUserDto } from "src/app/shared/dto/LoggedInUserDto";
import { InactivityService } from 'src/app/services/inactivity.service';
import { StatsService } from 'src/app/services/stats.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
    version = theGlobals.versionNum;
    copyYear = new Date().getFullYear();    // copyright year
    environ: string = '';
    userRole = '';
    userName = '';
    numExpiringCases: number;
    isFirstLogin = false;
    authProvider = theGlobals.setEnv().authProvider;
    isAdmin = false;
    runningExpCases = false;

  constructor(private caseService: CaseService,
              private efileService: EfileService,
              private utilService: UtilitiesService,
              private cookieService: CookieService,
              private msalService: MsalService,
              private eventEmitter: EventEmitterService,
              private confirmationService: ConfirmationService,
              private messageService: MessageService,
              private systemService: SystemService,
              private _myUser: LoggedInUserDto,
              private inactivityService: InactivityService,
              private statsService: StatsService,
  ) { }

  ngOnInit() {
    this.utilService.doAudit('at home page, initialize bernie');
    this.efileService.initBernie();
    this.utilService.doAudit(theGlobals.isParodanTestSystem, 'isTestSystem:');
    if (theGlobals.isParodanTestSystem === true) {
      this.environ = 'TEST System';
    } else {
      this.environ = '';
    }
    this.numExpiringCases = -1;
    if (this.msalService.instance.getActiveAccount() != null) {
        this.utilService.doAudit('', 'initializing user info:');
        this.getUserInfo();
    } else {
      this.utilService.doAudit('', 'setting up listener');
      this.eventEmitter.invokeLoginEvent.subscribe((data) => {
        this.utilService.doAudit(data, 'got user info from topbar:');
        this.getUserInfo();
      });
    }
  }

  isAdminOLD(): boolean {
    if (this.msalService.instance.getActiveAccount() != null) {
      if (this.userRole === '') { // if we don't have user info, get it from cookies and wait for next cycle...
        this.utilService.doAudit('no userRole found', 'isAdmin:');
        this.getUserInfo();
        return false;
      }
      if (this.userRole.includes('COB') == true || this.userRole.toUpperCase().substring(0, 5) === 'ADMIN') {
        return true;
      } else { return false; }
    } else { return false;}
  }

  getUserInfo() {
    this.utilService.doAudit('getting user info');
    this.userRole = this.cookieService.get('userRole');
    this.userName = this.cookieService.get('userName');
    this.utilService.doAudit(this.userRole, 'Role');
    this.utilService.doAudit(this.userName, 'Name');
    if (this.userRole.includes('COB') == true || this.userRole.toUpperCase().substring(0, 5) === 'ADMIN') {
      this.isAdmin = true;
    } else { this.isAdmin = false; }
    // check if this is the user's first login (ever!) - used for displaying County banner/disclaimer
    let isFirst = this.cookieService.get('isFirstLogin');
    if (isFirst == "1") {
      this.viewDisclaimer();
    } else {
        this.runExpiringCasesReport();
    }
  }

  viewDisclaimer() {
    this.utilService.doAudit('getting disclaimer text');
    let disclaimText = 'Warning text goes here<br><br>Have you read the warning and agree to the terms described therein?';
    this.systemService.getDisclaimer().subscribe(disclaimer => {
      this.utilService.doAudit(disclaimer, 'disclaimer:');
      if (disclaimer) {
        disclaimText = disclaimer.f8;
      }
      this.confirmDisclaimer(disclaimText);
    });
  }
  confirmDisclaimer(disclaimText: string) {
    this.utilService.doAudit(disclaimText, 'got disclaimer, confirming:');
    this.confirmationService.confirm({
      message: disclaimText,
      header: 'County Notification',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.systemService.confirmDisclaimer(this.userName).subscribe(data => {
          if (data == true) {
            // update FirstLogin cookie
            this.cookieService.set('isFirstLogin', '0');
            this.showToast({severity: 'success', detail: 'Disclaimer accepted.', summary: 'Info'});
            this.runExpiringCasesReport();
          } else {
            this.showToast({severity: 'error', detail: 'Disclaimer was NOT accepted! - Logging off...', summary: 'Info'});
            this.clearCookiesAndLogout();
          }
        });
      },
      reject: () => {
        this.showToast({severity: 'info', detail: 'System access has been denied.', summary: ''});
        this.clearCookiesAndLogout();
      },
    });
  }
  // this method is run ONLY once, during init...
  runExpiringCasesReport() {
    if (this.isAdmin == false) { return; }
    this.utilService.doAudit('Getting expiring cases count', '');
    // initialize the graph definition, dataset
    this.runningExpCases=true;
    this.statsService.getExpiringCasesCount().subscribe(data => {
      this.utilService.doAudit(data, 'response from expiring cases count...');
      if (data > -1) {
        this.runningExpCases=false;
        this.numExpiringCases = data;
      }
    });
  }

  // Toast-related methods
  showToast(msg: Message) {
    this.messageService.add(msg);
  }
  showConfirm() {
    this.messageService.clear();
    this.messageService.add({key: 'c', sticky: true, severity: 'warn', summary: 'Are you sure?', detail: 'Confirm to proceed'});
  }
  onConfirm() {
    this.messageService.clear('c');
  }
  onReject() {
    this.messageService.clear('c');
  }
  clear() {
    this.messageService.clear();
  }
  //
  clearCookiesAndLogout() {
    this.utilService.doAudit('Clear current user/cookies.');
    this._myUser = {
      userName: '',
      userRole: '',
      email: ''
    };
    this.cookieService.delete('userRole');
    this.cookieService.delete('userName');
    this.cookieService.delete('isFirstLogin');
    if (this.authProvider === 1) {
      this.msalService.logout();
    }
  }
}
